/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SignInBody = zod
	.object({
		identifier: zod.string().describe('Email or username'),
		password: zod.string().describe('Password')
	})
	.describe('Sign in request body');

export type SignInBody = zod.input<typeof SignInBody>;
export type SignInBodyOutput = zod.output<typeof SignInBody>;
